import React, {useContext} from "react"
import BrandFacts from "../BrandFacts"
import Typography from "../../reusable/Typography/Typography"
import CircleAnimations from "./CircleAnimations"
import LayoutContext from "../../../context/LayoutContext"
import DataContext from "../../../context/DataContext"
import {WithBrand, WithoutBrand} from "../../../utility/Types"
import {useTranslation} from "next-i18next"

function WithAndWithoutBrand() {
	const {isMobile} = useContext(LayoutContext)
	const {brandWorld} = useContext(DataContext)
	const {t} = useTranslation()
	return (
		<div className="with-and-without-brand container">
			<div style={{gap: "32px"}}
				className="d-flex align-items-center position-relative justify-content-center flex-column">
				<CircleAnimations isBackgroundAnimation />
				<Typography variant="bodySmBlack"
					style={{fontSize: isMobile ? "40px" : "64px", color: "#fff", lineHeight: isMobile ? "48px" : "76.8px", zIndex: "10"}}>{`${t("with-label")} ${brandWorld.brandName}`}</Typography>
				<BrandFacts facts={brandWorld?.withBrand as WithBrand[] } />
			</div>
			<div style={{gap: "32px"}}
				className="d-flex align-items-center justify-content-center flex-column">
				<Typography variant="bodySmBlack"
					style={{fontSize: isMobile ? "40px" : "64px", color: "#fff", lineHeight: isMobile ? "48px" : "76.8px", zIndex: "10"}}>{`${t("without-label")} ${brandWorld.brandName}`}</Typography>
				<BrandFacts facts={brandWorld.withoutBrand as WithoutBrand[]} />
			</div>
		</div>
	)
}

export default WithAndWithoutBrand
